import React from 'react';

function Footer() {
  return (
    <footer className="pb-30 pt-30">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <p className="fz-13">
                © 2025 Built with React & love by{" "}
                <span style={{ color: "#c8f21d" }}>Mughira Khalid</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
